import ComponentCatalog from './ComponentCatalog';

export default ComponentCatalog;
